import LinearProgress from '@mui/material/LinearProgress';
import '../css/Loading.css'
import { useState } from 'react';

export default function LoadingScreen() {
    return(
        <div className="loading-mod">
                <h2>donotes</h2>
                <LinearProgress sx={{width: 300}} />    
                
        </div>
    )
}